import React from 'react';
import { Modal, FormGroup, Button } from 'react-bootstrap';
import { Label } from 'fw/components';
import NaicsCodeMultiAuto from '../controls/NaicsCodeMultiAuto';

// NVBDC-1404 — search/pick/remove NAICS codes, staged into local one-sheet state only (Phase 2
// "stage locally" save model — no independent API call on Save here, same as the other popups).
class NaicsCodesPopUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = (props) => {
        return {
            visible: props.visible,
            value: this.toOptions(props.naicsCodes),
            originalIdByCode: this.toIdMap(props.naicsCodes)
        };
    };

    componentWillReceiveProps(nextProps) {
        this.setState({
            visible: nextProps.visible,
            value: this.toOptions(nextProps.naicsCodes),
            originalIdByCode: this.toIdMap(nextProps.naicsCodes)
        });
    }

    toOptions = (naicsCodes) => {
        return (naicsCodes || []).map(x => ({ value: x.naicsCodeId, label: x.naicsDescription }));
    };

    // Preserve each existing row's own BusinessStructureNAICSCodeId, keyed by NAICSCodeId, so
    // Save doesn't churn (delete+recreate) codes the user never touched — only genuinely new
    // picks should go to the backend as id 0.
    toIdMap = (naicsCodes) => {
        const map = {};
        (naicsCodes || []).forEach(x => { map[x.naicsCodeId] = x.businessStructureNAICSCodeId; });
        return map;
    };

    onChange = (options) => {
        this.setState({ value: options || [] });
    };

    save = () => {
        const naicsCodes = this.state.value.map(x => ({
            businessStructureNAICSCodeId: this.state.originalIdByCode[x.value] || 0,
            naicsCodeId: x.value,
            naicsDescription: x.label
        }));

        this.props.onSave(naicsCodes);
        this.close();
    };

    close = () => {
        this.setState({ visible: false }, () => this.props.onClose());
    };

    render() {
        return (
            <Modal show={this.state.visible} onHide={this.close}>
                <Modal.Header>
                    <h3>Company NAICS Codes</h3>
                </Modal.Header>
                <Modal.Body>
                    <FormGroup>
                        <Label htmlFor="naicsCodes" required>Search and select your company's NAICS codes</Label>
                        <NaicsCodeMultiAuto
                            id="naicsCodes"
                            name="naicsCodes"
                            value={this.state.value}
                            onChange={this.onChange}
                        />
                    </FormGroup>
                </Modal.Body>
                <Modal.Footer>
                    <Button id="btnSaveNaicsCodes" bsStyle="success" onClick={this.save}>Save</Button>
                    <Button id="btnCloseNaicsCodes" onClick={this.close}>Close</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default NaicsCodesPopUp;



// WEBPACK FOOTER //
// ./src/areas/certification/oneSheet/popups/NaicsCodesPopUp.js